import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class Brightness extends BaseOption {
  static userInterfaceComponent = {
    label: "Brightness",
    component: inspectorTools.SIMPLE_INPUT,
    props: {
      inputType: "number",
      min: 0,
      append: "%",
    },
  };

  static defaultValue = 100;

  static convertConfigValueToCompiledValue(configValue) {
    if (configValue === undefined || configValue === "") {
      return 100 + "%";
    }

    if (configValue === 0) {
      return 0;
    }
    return `${configValue}%`;
  }
}
